import SafeBackgroundImage from './SafeBackgroundImage';

export default SafeBackgroundImage;
